import ValidSignAccountModal from './ValidSignAccountModal';

export default ValidSignAccountModal;
